var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55016 19.5007C16.6045 19.5007 21.5583 11.9974 21.5583 5.49259C21.5583 5.28166 21.5536 5.06603 21.5442 4.85509C22.5079 4.15819 23.3395 3.29499 24 2.30603C23.1025 2.70533 22.1496 2.96611 21.1739 3.07947C22.2013 2.46364 22.9705 1.4962 23.3391 0.356499C22.3726 0.92929 21.3156 1.33334 20.2134 1.55134C19.4708 0.762293 18.489 0.239849 17.4197 0.0647834C16.3504 -0.110282 15.2532 0.0717828 14.2977 0.582829C13.3423 1.09387 12.5818 1.90544 12.1338 2.89204C11.6859 3.87865 11.5754 4.98535 11.8195 6.04103C9.86249 5.94282 7.94794 5.43444 6.19998 4.54883C4.45203 3.66323 2.90969 2.42017 1.67297 0.900249C1.0444 1.98398 0.852057 3.26638 1.13503 4.48682C1.418 5.70727 2.15506 6.77418 3.19641 7.47072C2.41463 7.4459 1.64998 7.23541 0.965625 6.85666V6.91759C0.964925 8.05488 1.3581 9.15732 2.07831 10.0375C2.79852 10.9177 3.80132 11.5213 4.91625 11.7457C4.19206 11.9439 3.43198 11.9727 2.69484 11.8301C3.00945 12.8082 3.62157 13.6636 4.44577 14.2771C5.26997 14.8905 6.26512 15.2313 7.29234 15.252C5.54842 16.6218 3.39417 17.3649 1.17656 17.3613C0.783287 17.3607 0.390399 17.3366 0 17.2892C2.25286 18.7345 4.87353 19.5021 7.55016 19.5007Z",
    fill: "#98A2B3",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.6c23bb93879eafce91d2e65a9a8c0f47.svg";
export { ForwardRef as ReactComponent };